<template>
	<div class="page">
		<div class="box_1">
			<div class="group_1">
				<!-- Logo区域 -->
				<div class="logo-container">
					<img src="@/assets/icon/icon_register.png" alt="五行商会">
				</div>
				<div class="block_2">
					<div style="display: none;justify-content: flex-end;">
						<van-popover v-model="showPopover" trigger="click" placement="bottom-start" :offset="[0, 0]"
							:actions="actions" @select="onSelect">
							<template #reference>
								<div class="lan-label">
									<img :src="lan_ico" alt="">
									<span>{{ lan_num }}</span>
								</div>
							</template>
						</van-popover>
					</div>

					<div class="item">
						<img src="@/assets/icon/icon_register_user.svg" alt="账号" class="icon">
						<input v-model.trim="data.mobile" type="text" class="inp" placeholder="请输入手机号码">
					</div>

					<div class="item">
						<img src="@/assets/icon/icon_register_lock.svg" alt="密码" class="icon">
						<input v-model.trim="data.password" :type="passwordType" class="inp"
							:placeholder="$t('register.password')">
						<span class="eye_bi" style="display:inline-block;vertical-align: sub;"
							:class="passwordType == 'text' ? 'eye' : ''" @click="togglePasswordVisibility"></span>
					</div>

					<div class="item">
						<img src="@/assets/icon/icon_register_lock.svg" alt="确认密码" class="icon">
						<input v-model.trim="data.spassword" :type="confirmPasswordType" class="inp"
							:placeholder="$t('register.passwordAgain')">
						<span class="eye_bi" style="display:inline-block;vertical-align: sub;"
							:class="confirmPasswordType == 'text' ? 'eye' : ''"
							@click="toggleConfirmPasswordVisibility"></span>
					</div>

					<div v-if="show_sms > 0" class="item">
						<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
						<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
							<template v-slot="timeData">
								<span @click="sendcode" style="color: #FFB13A; font-size: 0.37rem;">{{
									timeData.seconds > 0
										? timeData.seconds + 's'
										: $t('register.sendCode')
								}}</span>
							</template>
						</van-count-down>
					</div>

					<div class="item">
						<img src="@/assets/icon/icon_register_team.svg" alt="邀请码" class="icon">
						<input v-model.trim="data.invitation_code" type="text" class="inp" placeholder="请输入邀请码">
					</div>

					<div class="item_reset_pwd">
						<van-checkbox v-model="checked" shape="square" icon-size="14px">
							已阅读并同意隐私条款及服务协议
						</van-checkbox>
					</div>

					<div type="submit" class="basic_btn sbtn"
						:class="data.mobile == '' || data.password == '' ? 'no_touch' : ''" @click="submit">
						注册账户
					</div>
					<div type="submit" class="basic_btn sbtn" @click="$router.push('/login')"
						style="margin-top: 0; margin-bottom: 0;">
						返回登录
					</div>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		CountDown,
		Checkbox,
		Dialog,
		Popover
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(CountDown)
		.use(Checkbox)
		.use(Dialog)
		.use(Popover);

	export default {
		name: "Register",
		data() {
			return {
				checked: false,
				time: 0,
				show_kefu: false,
				show_sms: 0,
				passwordType: "password", // 密码输入框类型
				confirmPasswordType: "password", // 确认密码输入框类型
				data: {
					password: "",
					spassword: "",
					mobile: "",
					invitation_code: "",
					code: "",
					agent: 10000
				},
				showPopover: false,
				actions: [{
						text: '中国',
						icon: require('../images/language/zh_cn.png'),
					},
					{
						text: 'English',
						icon: require('../images/language/en_us.png'),
					},
					{
						text: '日本',
						icon: require('../images/language/ja_jp.png'),
					},
					{
						text: 'Brasil',
						icon: require('../images/language/ko_kr.png'),
					},
					{
						text: 'Việt Nam',
						icon: require('../images/language/vi_vn.png'),
					},
					{
						text: 'Malaysia',
						icon: require('../images/language/th_th.png'),
					},
					{
						text: 'ประเทศไทย',
						icon: require('../images/language/ms_my.png'),
					},
					{
						text: 'Indonesia',
						icon: require('../images/language/zh_hk.png'),
					},
				],
				lan_num: '中国',
				lan_ico: require('../images/language/zh_cn.png'),
				config: {}
			};
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
		},
		mounted() {
			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			Fetch('/index/webconfig', {
				type: 'web'
			}).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
		},
		methods: {
			// 切换密码可见性
			togglePasswordVisibility() {
				this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
			},
			// 切换确认密码可见性
			toggleConfirmPasswordVisibility() {
				this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password';
			},
			onSelect(action) {
				console.log(action)
				this.lan_ico = action.icon
				this.lan_num = action.text
				let lang
				if (action.text == "中国") {
					lang = "zh_cn"
				}
				if (action.text == "English") {
					lang = "en_us"
				}
				if (action.text == "日本") {
					lang = "ja_jp"
				}
				if (action.text == "Brasil") {
					lang = "ko_kr"
				}
				if (action.text == "Việt Nam") {
					lang = "vi_vn"
				}
				if (action.text == "Malaysia") {
					lang = "th_th"
				}
				if (action.text == "ประเทศไทย") {
					lang = "ms_my"
				}
				if (action.text == "Indonesia") {
					lang = "zh_hk"
				}
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
			},
			downloads() {
				this.$router.push("/downloadApp");
			},
			kefu_to() {
				Fetch('/user/system_info').then((r) => {
					window.location.href = r.data.service
				});
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				var info = JSON.parse(info);
				console.log(info);
				if (info.code == 0) {
					this.data.oaid = info.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				this.data.invitation_code = m;
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				if (!this.data.mobile) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
						mobile: this.data.mobile,
					})
					.then(() => {
						this.time = 60 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				if (!this.data.mobile) {
					this.$toast({
						className: "toastName",
						message: this.$t('register.phoneEmpty'),
					});
					return false;
				}
				if (!this.data.password) {
					this.$toast({
						className: "toastName",
						message: this.$t('register.passwordEmpty'),
					});
					return false;
				}
				if (!this.data.spassword) {
					this.$toast(this.$t('register.passwordAgainEmpty'));
					return false;
				}

				if (!this.data.code && this.config.sms_verify) {
					this.$toast({
						className: "toastName",
						message: this.$t('register.codeEmpty'),
					});
					return false;
				}
				if (this.data.password != this.data.spassword) {
					this.$toast(this.$t('register.passwordError'));
					return false;
				}
				if (!/^\d{6}$/.test(this.data.invitation_code)) {
					this.$toast('请填入正确邀请码');
					return false;
				}

				Fetch("/index/register", {
					...this.data,
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast({
						className: "toastName",
						message: this.$t('register.signUpSuccess'),
					});
					this.$router.replace("/");
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.page {
		position: relative;
		width: 10rem;
		height: 100vh;
		overflow: hidden;
	}

	.box_1 {
		height: 100vh;
		background: url(~@/assets/register_bg.png) 100% no-repeat;
		background-size: 100% 100%;
		width: 10rem;
	}

	.lan-label {
		display: flex;
		align-items: center;
		white-space: nowrap;
		height: 0.45rem;
		margin: .8rem .4rem 0 0;
		padding: 0 0.2rem;
		border-radius: 0.25rem;
		background: rgba(255, 255, 255, 0.8);

		span {
			display: inline-block;
			margin-left: 0.1rem;
			font-size: 0.3rem;
			color: #333;
		}

		img {
			width: 0.3rem;
			height: 0.3rem;
		}
	}

	.block_2 {
		width: 90%;
		height: auto;
		background: #FFFFFF;
		box-shadow: 0rem 0rem 0rem 0rem rgba(117, 117, 117, 0.2);
		border-radius: 0.31rem;
		padding-top: 0.75rem;
		padding-bottom: 0.5rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.basic_btn {
		margin: 0.65rem auto 0.43rem auto;
		width: 60%;
		height: 1.2rem;
		background: linear-gradient(269deg, #FDB44B, #FCE28B);
		border-radius: 0.6rem;
		color: #222222;
		font-family: SourceHanSansCN;
		font-weight: 400;
		font-size: 0.45rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.get_captcha {
		color: #FFB13A;
		font-size: 0.37rem;
		white-space: nowrap;
	}

	.logo-container {
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			width: 90%;
			margin-top: 15%;
		}
	}

	.input-icon {
		width: 0.5rem;
		height: 0.5rem;
		margin-right: 0.3rem;
		flex-shrink: 0;
	}

	.item {
		height: 1.2rem;
		width: 90%;
		background: #f7f7f7;
		border-radius: .6rem;
		padding: 0 15px;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 0 auto .4rem auto;

		.icon {
			width: 6.4vw;
			height: auto;
			text-align: center;
		}

		input {
			flex: 1;
			height: 1.2rem;
			color: #333;
			font-size: .43rem;
			font-family: SourceHanSansCN-Regular;
			font-weight: 400;
			text-align: left;
			margin-left: 7px;
		}
	}

	.item_reset_pwd {
		font-size: 3.2vw;
		line-height: 0.36rem;
		padding: 0 5%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	/deep/ .van-checkbox__icon--checked .van-icon {
		color: #fff;
		background-color: #FFB13A;
		border-color: #FFB13A;
	}

	/deep/ .van-checkbox__label {
		color: #999999;
		font-size: 3.2vw;
	}
</style>